import React, { useMemo } from 'react';
import type { WidgetSize } from '../../types/dashboard';
import { BucketPerformanceList } from './BucketPerformanceList';
import {
  OPENING_GAP_BUCKETS,
  buildBucketPerformance,
  getTradeOpeningGapPct,
} from '../../lib/trades/dashboardBucketAnalytics';

interface PerformanceByOpeningGapWidgetProps {
  timeRange: 'week' | 'month' | 'year';
  size: WidgetSize;
  trades?: any[];
}

export const PerformanceByOpeningGapWidget: React.FC<PerformanceByOpeningGapWidgetProps> = ({ 
  timeRange, 
  size, 
  trades = [],
}) => {
  const perfData = useMemo(
    () => buildBucketPerformance({ trades, timeRange, buckets: OPENING_GAP_BUCKETS, metric: getTradeOpeningGapPct }),
    [timeRange, trades]
  );

  return <BucketPerformanceList result={perfData} size={size} pctFormatter={(item) => `${item.pct.toFixed(2)}%`} />;
};